import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    countries: JSON.parse(localStorage.getItem('countries')) || [],
    currencies: JSON.parse(localStorage.getItem('currencies')) || [],
    supportedCoins: JSON.parse(localStorage.getItem('supportedCoins')) || [],
}

export const countriesSlice = createSlice({
    name: 'countries',
    initialState,
    reducers: {
        setCountries: (state, action) => {
            state.countries = action.payload;  
            localStorage.setItem('countries', JSON.stringify(state.countries));
        },
        setCurrencies: (state, action) => {
            state.currencies = action.payload;  
            localStorage.setItem('currencies', JSON.stringify(state.currencies));
        },
        setSupportedCoins: (state, action) => {
            state.supportedCoins = action.payload;  
            localStorage.setItem('supportedCoins', JSON.stringify(state.supportedCoins));
        }
    }
})

export const {setCountries, setCurrencies, setSupportedCoins} = countriesSlice.actions;
export default countriesSlice.reducer;
